// src/config/termsConditionsContent.js

const termsConditionsContent = {
    title: "Terms and Conditions",
    sections: [
      {
        heading: "Introduction",
        content: `
          These terms and conditions outline the rules and regulations for the use of the Morphologic website. 
          By accessing this website, we assume you accept these terms and conditions. Do not continue to use this website if you do not agree to take all of the terms and conditions stated on this page.
        `
      },
      {
        heading: "Eligibility",
        content: `
          To participate in the Ultimate Fluidity Challenge, participants must be at least 18 years old. 
          The competition is open to individuals worldwide, except where prohibited by law.
        `
      },
      {
        heading: "Intellectual Property",
        content: `
          All materials presented on this website, including but not limited to text, images, logos, and content, are the property of the Morphologic.
          Unauthorized use is prohibited.
        `
      },
      {
        heading: "Privacy Policy",
        content: `
          We are committed to protecting your privacy. The information you provide to us will be used solely for the purpose of this competition and will not be shared with third parties without your consent.
        `
      },
      {
        heading: "Limitation of Liability",
        content: `
          By participating, you agree that Morphologic is not responsible for any damages or losses incurred by participants, 
          including but not limited to, technical issues, personal injuries, or financial loss.
        `
      },
      {
        heading: "",
        content: `
          .
        `
      }
    ]
  };
  
  export default termsConditionsContent;
  
